// extracted by mini-css-extract-plugin
module.exports = {"row":"styles-module__row___dOaCU","col":"styles-module__col___mM9b9","submit":"styles-module__submit___8j76i"};